import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Tab panels/content to display. Typically a set of `TabPanel` components*/
  children: PropTypes.node.isRequired,
  /** Configuration for the tabs and keyboard navigation*/
  controls: PropTypes.shape({
    onKeyDown: PropTypes.func.isRequired,
    tabs: PropTypes.arrayOf(PropTypes.shape({
      ariaControls: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      isSelected: PropTypes.bool,
      subLabel: PropTypes.node
    })).isRequired
  }).isRequired,
  /** Accessible label for the tablist, describing the set of tabs*/
  labelText: PropTypes.string.isRequired,
  /** Layout direction for the tabs*/
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
};
function Tabs(_ref) {
  var children = _ref.children,
    controls = _ref.controls,
    labelText = _ref.labelText,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    "aria-label": labelText,
    "aria-orientation": orientation,
    className: "tabs",
    onKeyDown: controls.onKeyDown,
    role: "tablist",
    tabIndex: "-1"
  }, controls.tabs.map(function (_ref2) {
    var ariaControls = _ref2.ariaControls,
      id = _ref2.id,
      isSelected = _ref2.isSelected,
      label = _ref2.label,
      onClick = _ref2.onClick,
      ref = _ref2.ref,
      subLabel = _ref2.subLabel;
    return /*#__PURE__*/React__default.createElement("button", {
      "aria-controls": ariaControls,
      "aria-selected": isSelected || false,
      className: "tab-button",
      id: id,
      key: id,
      onClick: onClick,
      ref: ref,
      role: "tab",
      tabIndex: !isSelected ? -1 : null,
      type: "button"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "tab-button-label",
      "data-testid": "tab-button-label"
    }, label), subLabel ? /*#__PURE__*/React__default.createElement("span", {
      className: "tab-button-sub-label",
      "data-testid": "tab-button-sub-label"
    }, subLabel) : null);
  })), children);
}
Tabs.propTypes = propTypes;

export { Tabs as default };
//# sourceMappingURL=Tabs.js.map
